<div
    #big
    aria-hidden="true"
    class="absolute top-1/2 left-1/2 z-10 -mt-12 -ml-12 size-24 mask-contain mask-center mask-no-repeat"
    [style.background-color]="colors().big"
    [style.mask-image]="starMask"
></div>
<div
    #small
    aria-hidden="true"
    class="absolute top-1/2 left-1/2 -mt-[4.2px] -ml-[4.2px] size-[8.4px] mask-contain mask-center mask-no-repeat"
    [style.background-color]="colors().small"
    [style.mask-image]="starMask"
></div>
